import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Type declarations are used at compile-time as 'headers' only (does NOT include the files)

import { VersionUtils } from "abweb/utils/VersionUtils";
export class ImagePhysicalScale {
  constructor(path, width = NaN, height = NaN) {
    _defineProperty(this, "_path", void 0);
    _defineProperty(this, "_width", void 0);
    _defineProperty(this, "_height", void 0);
    this._path = VersionUtils.cacheBustUrl(path);
    this._width = width;
    this._height = height;
  }
  get path() {
    return this._path;
  }
  set path(value) {
    this._path = value;
  }
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
}
//# sourceMappingURL=ImagePhysicalScale.js.map
